import { useCallback, useEffect, useReducer, useState } from "react";

function reducer(state, action) {
  switch (action.type) {
    case "change":
      return { ...state, [action.payload.field]: action.payload.value };
    default:
      throw new Error();
  }
}

export default function useForm(initialForm, validateForm) {
  const [formValues, dispatch] = useReducer(reducer, initialForm);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((e) => {
    dispatch({
      type: "change",
      payload: { field: e.target.name, value: e.target.value },
    });
  }, []);

  useEffect(() => {
    if (validateForm) {
      const errors = validateForm(formValues);

      setErrors(errors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);

  return {
    values: { ...formValues },
    handleChange,
    errors,
  };
}
